import { StatusPill } from '@vnetwork/ui/data';
import {
  useIkePolicies,
  useCreateIkePolicy,
  useDeleteIkePolicy,
  useUpdateIkePolicy,
  useIpsecPolicies,
  useCreateIpsecPolicy,
  useDeleteIpsecPolicy,
  useUpdateIpsecPolicy,
} from '@/api/opennebula';
import { GenericList, mutedCell, lifetimeCell } from './GenericList';

export function IkeTab({ serviceId }: { serviceId: string }) {
  return (
    <GenericList title="IKE policies" list={useIkePolicies(serviceId)} create={useCreateIkePolicy(serviceId)} remove={useDeleteIkePolicy(serviceId)} update={useUpdateIkePolicy(serviceId)}
      fields={[{ key: 'name', label: 'Name' }, { key: 'ike_version', label: 'IKE version', placeholder: 'ikev2' }, { key: 'encryption_algorithm', label: 'Encryption', placeholder: 'aes256' }, { key: 'hash_algorithm', label: 'Hash', placeholder: 'sha256' }, { key: 'dh_group', label: 'DH group', placeholder: '14' }]}
      columns={[
        { id: 'name', header: 'Name', cell: ({ row }) => <b style={{ fontWeight: 500 }}>{row.original.name || row.original.id}</b> },
        { id: 'ver', header: 'IKE version', cell: ({ row }) => mutedCell(row.original.ike_version) },
        { id: 'enc', header: 'Encryption', cell: ({ row }) => mutedCell(row.original.encryption_algorithm) },
        { id: 'hash', header: 'Hash', cell: ({ row }) => mutedCell(row.original.hash_algorithm) },
        { id: 'dh', header: 'DH group', cell: ({ row }) => mutedCell(row.original.dh_group) },
        { id: 'life', header: 'Lifetime', cell: ({ row }) => lifetimeCell(row.original.lifetime) },
        { id: 'status', header: 'Status', cell: ({ row }) => <StatusPill tone={row.original.status === 'active' ? 'success' : 'muted'}>{row.original.status || 'Unknown'}</StatusPill> },
      ]} />
  );
}

export function IpsecTab({ serviceId }: { serviceId: string }) {
  return (
    <GenericList title="IPSec policies" list={useIpsecPolicies(serviceId)} create={useCreateIpsecPolicy(serviceId)} remove={useDeleteIpsecPolicy(serviceId)} update={useUpdateIpsecPolicy(serviceId)}
      fields={[{ key: 'name', label: 'Name' }, { key: 'protocol', label: 'Protocol', placeholder: 'esp' }, { key: 'encryption_algorithm', label: 'Encryption', placeholder: 'aes256' }, { key: 'hash_algorithm', label: 'Hash', placeholder: 'sha256' }, { key: 'pfs', label: 'PFS', placeholder: 'enable' }]}
      columns={[
        { id: 'name', header: 'Name', cell: ({ row }) => <b style={{ fontWeight: 500 }}>{row.original.name || row.original.id}</b> },
        { id: 'proto', header: 'Protocol', cell: ({ row }) => mutedCell(row.original.protocol) },
        { id: 'enc', header: 'Encryption', cell: ({ row }) => mutedCell(row.original.encryption_algorithm) },
        { id: 'hash', header: 'Hash', cell: ({ row }) => mutedCell(row.original.hash_algorithm) },
        { id: 'pfs', header: 'PFS', cell: ({ row }) => mutedCell(row.original.pfs) },
        { id: 'life', header: 'Lifetime', cell: ({ row }) => lifetimeCell(row.original.lifetime) },
        { id: 'status', header: 'Status', cell: ({ row }) => <StatusPill tone={row.original.status === 'active' ? 'success' : 'muted'}>{row.original.status || 'Unknown'}</StatusPill> },
      ]} />
  );
}
